/**
 * 保存和恢复 URL 参数的 hooks
 * 用于在 OAuth 授权流程中保存原始 URL 参数，授权完成后恢复
 */
export const useSavedUrlParams = (storageKey: string = "auth_saved_params") => {
  /**
   * 保存当前 URL 参数（排除指定的参数）
   * @param excludeParams 需要排除的参数列表
   */
  const saveUrlParams = (excludeParams: string[] = ["code", "state", "scopes", "error", "error_description"]) => {
    const currentParams = new URLSearchParams(window.location.search);
    const paramsToSave: Record<string, string> = {};

    currentParams.forEach((value, key) => {
      if (!excludeParams.includes(key)) {
        paramsToSave[key] = value;
      }
    });

    // 如果有需要保存的参数，存储到 sessionStorage
    if (Object.keys(paramsToSave).length > 0) {
      sessionStorage.setItem(storageKey, JSON.stringify(paramsToSave));
    }
  };

  /**
   * 恢复保存的 URL 参数，返回拼接好的 URL
   * @returns 拼接好的 URL 路径（包含查询参数）
   */
  const restoreSavedUrlParams = (): string => {
    const savedParamsStr = sessionStorage.getItem(storageKey);
    if (savedParamsStr) {
      try {
        const savedParams = JSON.parse(savedParamsStr);
        const params = new URLSearchParams();
        Object.keys(savedParams).forEach((key) => {
          params.append(key, savedParams[key]);
        });
        const queryString = params.toString();
        const newPath = queryString ? `${location.pathname}?${queryString}` : location.pathname;
        return newPath;
      } catch (error) {
        console.error("恢复 URL 参数失败:", error);
        return location.pathname;
      }
    }
    return location.pathname;
  };

  /**
   * 清除保存的参数
   */
  const clearSavedParams = () => {
    sessionStorage.removeItem(storageKey);
  };

  return {
    saveUrlParams,
    restoreSavedUrlParams,
    clearSavedParams,
  };
};
